import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ILocalError, IRemoteError } from '../model/errors.interface';
import { ERRORS_CONFIG } from '../tokens';

@Injectable({
  providedIn: 'root'
})
export class ErrorsService {
  private _errorsConfig = inject(ERRORS_CONFIG);

  constructor() {}

  throwRemoteError(error: IRemoteError): Observable<never> {
    error = {
      ...error,
      ...{
        origin: 'remote'
      }
    };
    return this.throwError<IRemoteError>(error);
  }

  throwLocalError(error: ILocalError): Observable<never> {
    const { message } = error;

    error = {
      ...error,
      ...{
        origin: 'local',
        message: this.formatLocalErrorMessage(message)
      }
    };

    return this.throwError<ILocalError>(error);
  }

  formatLocalErrorMessage(message: string) {
    const { localErrors } = this._errorsConfig;
    const { formatPrefix, formatSuffix } = localErrors;
    return `\n${formatPrefix}\n${message}\n${formatSuffix}\n\n`;
  }

  private throwError<T>(error: T): Observable<never> {
    throw error;
  }
}
